import type { SoapError } from '@easterngraphics/wcf/modules/eaiws';

const ExceptionNameRegExp: RegExp = /(([\w+\.]*?)\.([\w]+)Exception):/;
export function getEaiwsExceptionName(error: SoapError): string | undefined {
    return ExceptionNameRegExp.exec(error.message)?.[1];
}